import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { HowItWorksComponent } from "src/app/shared/components/how-it-works/how-it-works.component";
import {
  AuthService,
  Card,
  CardQuery,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
} from "@fgb/core";
import { Router, NavigationStart } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

@Component({
  selector: "fgb-mobile-nav-menu",
  templateUrl: "./mobile-nav-menu.component.html",
  styleUrls: ["./mobile-nav-menu.component.scss"],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  memberDetails$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;
  selectedMember: string;
  cards$: Observable<Card[]>;
  isHelpOpen: boolean = true;
  @ViewChild("howItWorksModal") howItWorksModal: HowItWorksComponent;
  constructor(
    private authService: AuthService,
    private router: Router,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private cardQuery: CardQuery
  ) {}
  private routerSubscription: Subscription;
  public isCollapsed = true;

  ngOnInit() {
    this.initMemberAccounts();
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => (this.isCollapsed = true))
      )
      .subscribe();
  }

  initMemberAccounts() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.cards$ = this.cardQuery.selectCards();
    this.selectedMember = this.memberQuery.getUserContext().memberId;
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  logout() {
    this.authService
      .logout()
      .toPromise()
      .then(() => this.router.navigate(["/login"]));
  }

  openHowItWorks() {
    this.howItWorksModal.openModal();
  }
}
